import React from "react";
import T from '../../../components/common/T';
import { useDailyLogs } from "../../../context/DailyLogContext";
import { useEmployees } from "../../../context/EmployeeContext";
import { PlusIcon, EyeIcon } from "@heroicons/react/24/outline";
import { formatDate } from "../../../utils/dateUtils";

export default function DailyLogList({ projectId, onOpenLog }) {
  const { getProjectLogs } = useDailyLogs();
  const { employees } = useEmployees();
  
  const logs = getProjectLogs(projectId);

  const getSupervisorName = (id) => {
    const emp = employees.find(e => String(e.id) === String(id));
    return emp ? emp.employeeName : "Unknown";
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-bold text-gray-700 dark:text-[#f0f6fc] text-sm md:text-base"><T>Site Daily Logs</T></h3>
        <button onClick={() => onOpenLog(null)} className="h-8 w-8 sm:w-auto px-0 sm:px-3 bg-[#D9531E] hover:bg-[#C24514] active:scale-[0.98] text-white rounded-lg text-xs font-bold uppercase flex items-center justify-center gap-1.5 shadow-sm transition shrink-0" title="Create Daily Log">
          <PlusIcon className="w-4 h-4"/> <span className="hidden sm:inline"><T>Create Daily Log</T></span>
        </button>
      </div>

      {logs.length === 0 ? (
        <div className="text-center p-8 border-2 border-dashed border-gray-200 dark:border-[#30363d] rounded-xl text-gray-400 dark:text-[#848d97]"><p className="text-sm"><T>No daily logs found for this project.</T></p></div>
      ) : (
        <div className="overflow-hidden bg-white dark:bg-[#161b22] border border-gray-200 dark:border-[#30363d] rounded-xl shadow-xs">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-50 dark:bg-[#21262d] text-xs font-bold text-gray-500 dark:text-[#848d97] uppercase border-b border-gray-200 dark:border-[#30363d]">
              <tr>
                <th className="px-4 py-3"><T>Date</T></th>
                <th className="px-4 py-3"><T>Reference</T></th>
                <th className="px-4 py-3"><T>Supervisor</T></th>
                <th className="px-4 py-3"><T>Weather</T></th>
                <th className="px-4 py-3"><T>Status</T></th>
                <th className="px-4 py-3 text-right"><T>Actions</T></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 dark:divide-[#30363d]">
              {logs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50 dark:hover:bg-[#21262d] transition">
                  <td className="px-4 py-3 font-medium text-gray-800 dark:text-[#f0f6fc]">{formatDate(log.date)}</td>
                  <td className="px-4 py-3 font-mono text-xs text-gray-500 dark:text-[#848d97]">{log.id}</td>
                  <td className="px-4 py-3 flex items-center gap-2 text-gray-800 dark:text-[#f0f6fc]">
                    <div className="w-6 h-6 rounded-full bg-orange-100 dark:bg-orange-950/40 text-[#D9531E] dark:text-[#F5875E] flex items-center justify-center text-xs font-bold">{getSupervisorName(log.supervisorId).charAt(0)}</div>
                    {getSupervisorName(log.supervisorId)}
                  </td>
                  <td className="px-4 py-3 text-gray-600 dark:text-[#848d97]">{log.weatherInfo.weather}, {log.weatherInfo.temperature}°{log.weatherInfo.temperatureUnit}</td>
                  <td className="px-4 py-3"><span className={`px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase border ${log.status === 'Submitted' ? 'bg-green-100 dark:bg-green-950/40 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800/50' : 'bg-yellow-100 dark:bg-yellow-950/40 text-yellow-700 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800/50'}`}>{log.status}</span></td>
                  <td className="px-4 py-3 text-right"><button onClick={() => onOpenLog(log)} className="text-gray-400 hover:text-[#D9531E] dark:hover:text-[#F5875E] transition"><EyeIcon className="w-5 h-5" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}